"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ELECYTONIC_TYPE = exports.PAPER_TYPE = void 0;
var PAPER_TYPE = ['duplicate', 'triplicate', 'donation'];
exports.PAPER_TYPE = PAPER_TYPE;
var ELECYTONIC_TYPE = ['MANUAL', 'ECPAY'];
exports.ELECYTONIC_TYPE = ELECYTONIC_TYPE;